import React, { useContext, useEffect, useState } from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { navigate } from "gatsby";

// Components //
import CardRedLideres, { ICardRedLideres } from "../../molecules/lider-card/liderCard";
import FormRegistroLideres from "../../organisms/form-registro-lideres/FormRegistroLideres";
import TitleSection from "../../molecules/title-section";
import Button from "../../atoms/button/button";

// Services //
import { getFormData, getToken, getUserFormDataByQuestionId } from "../../../services/formServices";

// Utils //
import { getRandomItems } from "../../../utils/helpers";

// Context //
import GlobalContext from "../../../contexts/globalContext";

// Syles //
import "./conoceLideres.scss";

const ConoceRedLideres = (props: ReferenciaContenido) => {

    const [liderCards, setLiderCards] = useState<ICardRedLideres[]>([]);
    const liderNoFoto = require("../../../../static/lider-nofoto.png").default;
    const [isLeader, setIsLeader] = useState(false);
    const [displayForm, setDisplayForm] = useState(false)
    const Context = useContext(GlobalContext);


    const conoceRedAction = () => {
        if (isLeader) {
            navigate(props.redireccionBoton);
        } else {
            setDisplayForm(true)
        }
    }

    const getLeaderDataProfile = async () => {
        const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
        const dataFormLeader = await getUserFormDataByQuestionId(token, 5, "documentId", Context?.gigyaContext?.gigyaAccount?.data.docNumber);
        setIsLeader(!!(dataFormLeader.data.answerData?.documentId));
    }

    const getLeaderDataCards = async () => {
        const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
        const response = await getFormData(5, token);

        const cardData: ICardRedLideres[] = [];
        response.data.forEach((liderData) => {
            const item = liderData.answerData;
            if (item.documentId != Context?.gigyaContext?.gigyaAccount?.data.docNumber) {
                item.liderFoto = item.profilePicture ? item.profilePicture : liderNoFoto;
                cardData.push(item);
            } else {
                setIsLeader(true);
            }
        });
        const randomCards = getRandomItems(cardData, 3);
        setLiderCards(randomCards);
    };

    const updateDisplayForm = (state: boolean) => { setDisplayForm(state) }

    useEffect(() => {
        getLeaderDataCards();
    }, []);

    useEffect(() => {
        getLeaderDataProfile();
    }, [Context?.gigyaContext?.gigyaAccount]);

    return (
        <>
            <div className="m-cmnd-banner-conoce conoce-red">
                <TitleSection
                    title={props.tituloGeneral}
                    introText={props.descripcion.json.content[0].content[0].value}
                />
                <div className="red-lideres-cards">
                    {liderCards.map((item, index) => (
                        <CardRedLideres
                            profilePicture={item.profilePicture ? item.profilePicture : liderNoFoto}
                            name={item.name}
                            companyRoleDescription={item.companyRoleDescription}
                            companyName={item.companyName}
                            companyRole={item.companyRole}
                            mobile={item.mobile}
                            documentId={item.documentId}
                            key={index}
                        />
                    ))}
                </div>
                <div className="button-wrapper">
                    <Button
                        type="button"
                        text={props.tituloBoton}
                        classname="a-button__magenta gtm_conoce_otros_lideres_home_comunidades"
                        href={void (0)}
                        isDisabled={false}
                        onClickAction={conoceRedAction}
                    />
                </div>
            </div>

            {/* MODAL REGISTRO LIDER */}
            <FormRegistroLideres displayForm={displayForm} setDisplayForm={updateDisplayForm} />

        </>
    );
};

export default ConoceRedLideres;
